export default (events=[],action)=>{
    if(action.type==="FETCH_EVENTS"){
       return action.payload;
    }
    return events;
}
